const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").trim();

export const API_BASE_URL = (configuredBaseUrl || "http://localhost:5000").replace(/\/+$/, "");
